import React, {FunctionComponent, useMemo} from "react";
import {getCookie} from "@klear/common-utils";

const styles = require('./header.component.scss');

export const Header: FunctionComponent = () => {
    const userConnected = useMemo( () => !!getCookie('klear_gatsby') ,[typeof window]);

    return (
        <>
             {/*<header className={styles.header2020}>
                <a className={styles.newLogo} href="/" title="Influencer Marketing Platform"> */}
                    {/* TODO change before going live */}
                    {/*<img src="https://dev10.klear.com/images/openSiteNew/logo/klear_logo_2.png" alt=""/>
                </a>
                <div className={styles.headerTabs}>
                    <nav>
                        <ul className={styles.nav2020}>
                            <li>
                                <div onMouseEnter={event => klearDropdownFuncs.open('whyklear')(event)}
                                     onTouchEnd={event => klearDropdownFuncs.toggle('whyklear')(event)}
                                     onMouseDown={event => klearDropdownFuncs.leave(event)}
                                    className={styles.oneTab}>Why Klear? <i className="fa fa-caret-down"/></div>
                            </li>
                            <li>
                                <div onMouseEnter={event => klearDropdownFuncs.open('product')(event)}
                                     onTouchEnd={event => klearDropdownFuncs.toggle('product')(event)}
                                     onMouseDown={event => klearDropdownFuncs.leave(event)}
                                    className={styles.oneTab}>Solutions <i className="fa fa-caret-down"/></div>
                            </li>
                            <li>
                                <a className={styles.oneTab} href="/pricing"
                                   title="Klear Pricing ">Pricing</a>
                            </li>
                            <li>
                                <div onMouseEnter={event => klearDropdownFuncs.open('learn')(event)}
                                     onTouchEnd={event => klearDropdownFuncs.toggle('learn')(event)}
                                     onMouseDown={event => klearDropdownFuncs.leave(event)}
                                     className={styles.oneTab}>Resources<i className="fa fa-caret-down"/></div>
                            </li>
                            <li>
                                <a
                                    className={styles.oneTab} href="/creators"
                                    title="Klear Pricing">Creators</a>
                            </li>
                        </ul>
                    </nav>
                    <div className={styles.rightSide}>
                        {userConnected ?
                                <div>
                                    <a href="/proHome/" className={styles.butt2020}> My Dashboard </a>
                                </div>
                        :
                            <>
                                <a className={styles.oneTab} href="/sign-in" title="Klear Sign In">Sign In</a>
                                <a href="/pricing" className={styles.butt2020}>
                                    Live Demo
                                </a>
                            </>
                        }
                    </div>
                </div>
                <div className={`btn-group ${styles.showOnMobileFlex} ${styles.hamburgerIcon}`}>
                    <div className="hamburgerDropDown" onClick={() => setMobileDrawerOpen(true)}>
                        <i className="fa fa-bars" style={{fontSize: 'var(--text-big)'}}/>
                    </div>
                </div>
                <HeaderMenuDrawer open={mobileDrawerOpen} onClose={() => setMobileDrawerOpen(false)}/>
                    </header>*/}
            <header className={styles.mwstyle}>
                <div className={styles.logo}><a href="/"><img src="/images/new/logo/klear_logo.png" alt={'Klear Logo'}/></a></div>
                <input className={styles.hamburger} id="hamburger" type="checkbox" />
                <label htmlFor="hamburger"><span></span><span></span><span></span><span></span></label>
                <nav role="navigation">
                    <ul>
                    <li>
                        <input id="why-dropdown" type="checkbox"/>
                        <label htmlFor="why-dropdown" tabIndex={0}>Why Klear?</label>
                        <div className={styles.dropdown}>
                        <ul>
                            <li><a href="/features/find-influencers/">Find Influencers</a></li>
                            <li><a href="/features/influencer-analysis/">Influencer Analytics</a></li>
                            <li><a href="/features/influencer-relationship-management/">Manage Relationships</a></li>
                            <li><a href="/features/activate-influencers/">Activate Influencers</a></li>
                            <li><a href="/features/influencer-program/">Measure Campaigns</a></li>
                        </ul>
                        </div>
                    </li>
                    <li>
                        <input id="solutions-dropdown" type="checkbox"/>
                        <label htmlFor="solutions-dropdown" tabIndex={0}>Solutions</label>
                        <div className={styles.dropdown}>
                        <ul>
                            <div className={styles.heading}>By Network</div>
                            <li><a href="/solutions/instagram-influencers/">Instagram</a></li>
                            <li><a href="/solutions/youtube-influencers/">YouTube</a></li>
                            <li><a href="/solutions/tiktok-influencers/">TikTok</a></li>
                        </ul>
                        <ul>
                            <div className={styles.heading}>By Business Type</div>
                            <li><a href="/solutions/enterprise/">Enterprise</a></li>
                            <li><a href="/solutions/agencies/">Agency</a></li>
                            <li><a href="/solutions/e-commerce/">E-Commerce</a></li>
                        </ul>
                        </div>
                    </li>
                    <li><a href="/pricing">Pricing</a></li>
                    <li>
                        <input id="resources-dropdown" type="checkbox"/>
                        <label htmlFor="resources-dropdown" tabIndex={0}>Resources</label>
                        <div className={styles.dropdown}>
                        <ul>
                            <div className={styles.heading}>Resources</div>
                            <li><a href="/case-studies/">Case Studies</a></li>
                            <li><a href="/blog/">Blog</a></li>
                            <li><a href="/resources">Influencer Marketing Guide</a></li>
                            <li><a href="/what-is-influence">What is Influence?</a></li>
                        </ul>
                        <ul>
                            <div className={styles.heading}>Free Tools</div>
                            <li><a href="/free-tools/influencer-pricing-calculator">Influencer Pricing Calculator</a></li>
                            <li><a href="/free-tools/facebook-analysis">Facebook Page Analysis</a></li>
                            <li><a href="/free-tools/twitter-analysis">Twitter Analysis</a></li>
                            <li><a href="/free-tools/find-influencers-by-location">Top Influencers by Location</a></li>
                            <li><a href="/free-tools/find-twitter-influencers">Find Twitter Influencers</a></li>
                        </ul>
                        <ul>
                            <div className={styles.heading}>Reports</div>
                            <li><a href="/reports/2020-influencer-rate-report/">Influencer Pricing Report</a></li>
                            <li><a href="/reports/2022-state-of-influencer-marketing-report/">State Of Influencer Marketing</a></li>
                            <li><a href="/reports/ambassador-program-white-paper/">Ambassador Programs Guide</a></li>
                            <li><a href="/reports/klear-influencer-inspiration-guide/">Influencer Inspiration Guide</a></li>
                        </ul>
                        </div>
                    </li>
                    <li><a href="/creators">Creators</a></li>
                    </ul>
                    <div className={styles.right}>
                        {userConnected ?
                            <a key={'My Dashboard'} href="/proHome/" className={styles.ctaButton}> My Dashboard </a>
                        :
                            <>
                                <a className={styles.link} href="/sign-in" title="Klear Sign In">Sign In</a>
                                <a href="/pricing" className={styles.ctaButton}>
                                    Live Demo
                                </a>
                            </>
                        }
                    </div>
                </nav>
            </header>
        </>
    );
};
